import { h, FunctionalComponent } from 'preact';
import * as style from './mainOlay.scss';

interface MainPageOverlayProps {}

export const MainPageOverlay: FunctionalComponent<MainPageOverlayProps> = () => {
  return <div class={style.overlay}></div>;
};
